import _ from 'lodash';
import { notification, Icon, Tooltip } from 'antd';
import CategoryView from './CategoryView';
import TableScroller from '../../views/TableScroller';
import { Category, recordToID, categoryFetchAll, categoryRemoveRecords } from '../../store/models/Category';
import Button from '../../views/StyledButton';
import DeleteButtonRow from '../../views/DeleteButtonRow';
import EllipsisTitle from '../../views/EllipsisTitle';
import DateFormatter from '../../utils/DateFormatter';
import React from 'react';

function aToNum(cat) {
  const active = _.get(cat, 'active');
  return active ? 1 : 0;
}

const columns = ({ goCat, delCat, goReCat }) => ([
  {
    dataIndex: 'categoryName',
    title: 'Name',
    width: 200,
    render: text => <EllipsisTitle text={text} width={180} />,
  },
  { dataIndex: 'version', width: 40, title: 'Version', render: v => <div style={{ whiteSpace: 'nowrap' }}>{v}</div> },
  {
    dataIndex: 'categoryDescription',
    title: 'Description',
    render: (text, record) => <EllipsisTitle text={text} description={record.query} />,
  },
  {
    title: 'Tags',
    key: 'active',
    width: 300,
    dataIndex: 'active',
    render: (text, record) => {
      const tags = _.get(record, 'tags', []);
      const tagText = Array.isArray(tags) ? tags.join(', '): '';
      return <EllipsisTitle text={tagText} />;
    },
  }, {
    title: 'Created',
    key: 'dateCreated',
    width: 150,
    dataIndex: 'dateCreated',
    render: (text, record) => <div title={DateFormatter.formatUtc(record.dateCreated)}>{DateFormatter.formatUtcShort(record.dateCreated)}</div>,
    sorter: (vocA, vocB) => DateFormatter.compDate(
      _.get(vocA, 'dateCreated', ''),
      _.get(vocB, 'dateCreated', ''),
    ),
  },
  {
    key: 'controlButtons',
    dataKey: 'categoryName',
    width: 90,
    align: 'right',
    render: id => (<div style={{ whiteSpace: 'nowrap' }}>
        <Tooltip placement="topRight" title={'Re-Apply Category'}>
          <Button
            onClick={() => goReCat(id)}
            size="small"
          >
            <Icon type="sync" />
          </Button>
        </Tooltip>
        <Tooltip placement="topRight" title={'Edit Category'}>
          <Button
            onClick={() => goCat(id)}
            size="small"
          >
            <Icon type="edit" />
          </Button>
        </Tooltip>
          <DeleteButtonRow
            deleteFn={delCat}
            id={id}
            entityType="category"
          />
      </div>
    ),
  },
]);

export default (class CategoryContainer extends TableScroller {
  constructor(props) {
    super(props);
    this.state = {
      scrollY: 0,
      data: [],
      isLoading: false,
      isLoaded: false,
      loadError: false,
      showReCatModal: false,
    };
    this.goNew = this.goNew.bind(this);
    this.goHome = this.goHome.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.goCat = this.goCat.bind(this);
    this.goReCat = this.goReCat.bind(this);
    this.delCat = this.delCat.bind(this);

  }

  componentDidMount() {
    super.componentDidMount();
    this.loadCategories();
  }

  get token() {
    return _.get(this, 'props.ephemeralKey.bearerToken');
  }

  loadCategories() {
    if (this.token) {
      this.setState({ isLoading: true }, () => {
        categoryFetchAll(this.token)
          .then(categories => this.setState({
            data: categories.filter(cat => (cat.active)),
            isLoaded: true,
            isLoading: false,
            loadError: false,
          }, () => this.setTableScroll()))
          .catch(err => this.setState({
            isLoaded: false,
            isLoading: false,
            loadError: err.message,
          }, () => this.setTableScroll()));
      });
    } // @TODO: else user notifcation?
  }

  goHome() {
    this.props.history.push('/');
  }

  goNew() {
    this.props.history.push('/categories/new');
  }

  goCat(id) {
    if (!id) {
      return;
    }
    const cat = new Category({ categoryName: recordToID(id) });
    this.props.history.push(`/categories/drilldown/${cat.encodedID}`);
  }
  goReCat(id) {
    if (!id) {
      return;
    }
    this.setState({
      showReCatModal: true,
      categoryObj: id,
    });
  }

  closeModal() {
    this.setState({
      showReCatModal: false,
      categoryObj: {},
    });
  }

  delCat(id) {
    if (!id) {
      return;
    }
    // eslint-disable-next-line no-param-reassign
    id = recordToID(id);
    if (this.token) {
      this.setState({
        isLoading: true, loaded: false,
      }, () => {
        categoryRemoveRecords(id, this.token)
          .then(() => {
            notification.success({
              message: 'Delete Category',
              description: `Deleted category "${id}"`,
              duration: 2.5,
              placement: 'topLeft',
            });
            this.loadCategories();
          })
          .catch((err) => {
            notification.error({
              message: 'Delete Category',
              description: `cannot delete Category "${id}":
${_.get(err, 'message', '(unknown error)')}`,
              duration: 2.5,
              placement: 'topLeft',
            });
          });
      });
    }
  }

  render() {
    return this.freezeHeight(<CategoryView
      {...this.state}
      columns={columns({
        goCat: this.goCat,
        goReCat: this.goReCat,
        delCat: this.delCat,
      })}
      title="Categories"
      token={this.token}
      goNew={this.goNew}
      goHome={this.goHome}
      closeModal={this.closeModal}
    />);
  }
});
